<div class="view-info-request page">
  @if (isLoading) {
    <div class="fullscreen-loader">
      <app-spinner [isLoading]="true" />
    </div>
  } @else if (request) {
    <app-breadcrumbs [breadcrumbs]="breadcrumbs" />

    <!-- Header -->
    <div class="heading-wrapper">
      <h4>{{ getHeadingTitle() }}</h4>
      <div class="heading-right">
        <div class="status-badges">
          @if (paymentMarker) {
            <span class="payment-badge" [ngClass]="paymentMarker">
              <i class="bi" [ngClass]="paymentMarker === 'Paid' ? 'bi-check-lg' : 'bi-receipt'"></i>
              {{ 'pages.service.infoRequest.paymentState.' + paymentMarker | translate }}
            </span>
          }
          <span class="status" [ngClass]="[request.backofficeStatus]">
            {{ getBackofficeStatusLabel() }}
          </span>
          @if (request.isConsolidated) {
            <span class="consolidated-badge">
              <i class="bi bi-diagram-3-fill"></i>
              {{ 'pages.viewInfoRequest.consolidated' | translate }}
            </span>
          }
        </div>
        <div class="actions">
        @if (showStartPreliminaryButton) {
          <button class="primary" [disabled]="isActionLoading" (click)="startPreliminaryResearch()">
            {{ 'pages.viewInfoRequest.actions.startPreliminaryResearch' | translate }}
          </button>
        }
        <app-multi-option-button
          [showMenuIcon]="true"
          [options]="otherActionsOptions"
          [disabled]="otherActionsOptions.length === 0"
          [text]="'pages.viewInfoRequest.otherActions' | translate"
          (optionSelected)="onOtherActionSelected($event)"
          styleClass="secondary" />
        </div>
      </div>
    </div>

    <!-- Content with side nav -->
    <div class="content-wrapper">
      <app-content-side-nav
        [activeItem]="activeItem"
        [navItems]="navItems"
        [navItemsCounts]="navItemsCounts"
        [unreadIcon]="[hasUnreadMessages ? 'infoRequestCommunication' : '', hasActiveTasks ? 'infoRequestTasks' : '']"
        [shouldTranslate]="true"
        (itemSelected)="onNavItemSelected($event)" />

      <div class="active-content">
        @if (activeItem === 'infoRequestApplication') {

          <!-- Pamatinformācija (collapsible) -->
          <div class="collapsible-section">
            <div class="section-header" (click)="isBasicInfoExpanded = !isBasicInfoExpanded" (keydown.enter)="isBasicInfoExpanded = !isBasicInfoExpanded" tabindex="0">
              <div class="section-header-left">
                <img [ngClass]="{ chevron: true, open: isBasicInfoExpanded }" src="assets/images/chevron-icon.svg" alt="arrow" />
                <h5>{{ labels.section('basicData') }}</h5>
              </div>
              <div class="section-actions" (click)="$event.stopPropagation()">
                @if (isBasicInfoEditMode) {
                  <button class="secondary" (click)="cancelBasicInfoEdit()">
                    {{ 'pages.viewInfoRequest.basicInfo.cancel' | translate }}
                  </button>
                  <button class="primary" [disabled]="isActionLoading" (click)="saveBasicInfo()">
                    {{ 'pages.viewInfoRequest.basicInfo.save' | translate }}
                  </button>
                } @else {
                  <button class="tertiary" (click)="downloadPdf()">
                    <i class="bi bi-file-earmark-arrow-down"></i>
                    {{ 'pages.viewInfoRequest.savePdf' | translate }}
                  </button>
                  @if (canEditRequest) {
                    <button class="tertiary" (click)="enterBasicInfoEdit()">
                      {{ 'pages.viewInfoRequest.edit' | translate }}
                    </button>
                  }
                }
              </div>
            </div>
            <div [ngbCollapse]="!isBasicInfoExpanded">
              @if (isBasicInfoEditMode) {
                <!-- Edit mode -->
                <div class="section-body">
                  <form [formGroup]="basicInfoForm">
                    <div class="edit-form-grid">
                      <div class="info-field">
                        <p class="form-label lna">{{ labels.field('basicData', 'requestNumber') }}</p>
                        <p class="field-value">{{ request.code || '-' }}</p>
                      </div>
                      <div class="info-field">
                        <p class="form-label lna">{{ labels.field('basicData','submittedOn') }}</p>
                        <p class="field-value">{{ request.submittedOn ? formatDatetime(request.submittedOn, false) : (request.createdOn ? formatDatetime(request.createdOn, false) : '-') }}</p>
                      </div>
                    </div>

                    <div class="edit-field">
                      <label class="form-label lna">
                        {{ labels.field('basicData','submissionChannel') }}
                        <span class="required-field">*</span>
                      </label>
                      <div class="radio-group" [class.disabled-option]="request.submissionChannel === 'Portal'">
                        <label class="radio-option" [class.disabled-option]="request.submissionChannel !== 'Portal'">
                          <input type="radio" value="Portal" formControlName="submissionChannel" (click)="request.submissionChannel !== 'Portal' ? $event.preventDefault() : null" />
                          {{ 'pages.viewInfoRequest.basicInfo.channelPortal' | translate }}
                        </label>
                        <label class="radio-option">
                          <input type="radio" value="Email" formControlName="submissionChannel" />
                          {{ 'pages.viewInfoRequest.basicInfo.channelEmail' | translate }}
                        </label>
                        <label class="radio-option">
                          <input type="radio" value="Namejs" formControlName="submissionChannel" />
                          {{ 'pages.viewInfoRequest.basicInfo.channelNamejs' | translate }}
                        </label>
                        <label class="radio-option">
                          <input type="radio" value="PostalMail" formControlName="submissionChannel" />
                          {{ 'pages.viewInfoRequest.basicInfo.channelPostalMail' | translate }}
                        </label>
                        <label class="radio-option">
                          <input type="radio" value="Archive" formControlName="submissionChannel" />
                          {{ 'pages.viewInfoRequest.basicInfo.channelArchive' | translate }}
                        </label>
                      </div>
                    </div>

                    <div class="edit-field">
                      <label class="form-label lna">
                        {{ labels.field('basicData','serviceDeadline') }}
                        <app-tooltip text="infoRequestServiceDeadline" />
                      </label>
                      <div class="radio-group">
                        <label class="radio-option">
                          <input type="radio" value="Days30" formControlName="serviceDeadline" />
                          {{ 'pages.viewInfoRequest.basicInfo.deadlineDays30' | translate }}
                        </label>
                        <label class="radio-option">
                          <input type="radio" value="Days15" formControlName="serviceDeadline" />
                          {{ 'pages.viewInfoRequest.basicInfo.deadlineDays15' | translate }}
                          <span class="increased-fee">({{ 'pages.viewInfoRequest.basicInfo.increasedFee' | translate }})</span>
                        </label>
                        <label class="radio-option">
                          <input type="radio" value="Days10" formControlName="serviceDeadline" />
                          {{ 'pages.viewInfoRequest.basicInfo.deadlineDays10' | translate }}
                          <span class="increased-fee">({{ 'pages.viewInfoRequest.basicInfo.increasedFee' | translate }})</span>
                        </label>
                        <label class="radio-option">
                          <input type="radio" value="Other" formControlName="serviceDeadline" />
                          {{ 'pages.viewInfoRequest.basicInfo.deadlineOther' | translate }}
                        </label>
                      </div>
                      @if (basicInfoForm.get('serviceDeadline')?.value === 'Other') {
                        <div class="edit-form-grid" style="margin-top: 8px">
                          <div class="edit-field">
                            <label class="form-label lna">{{ labels.field('basicData', 'serviceDeadlineDate') }} <span class="required-field">*</span></label>
                            <app-date-picker
                              [date]="basicInfoForm.get('deadlineDate')?.value"
                              [dateRangeMode]="DateRangeMode.FutureAndToday"
                              (dateSelected)="onBasicInfoDeadlineDateSelected($event)" />
                          </div>
                        </div>
                      }
                    </div>

                    <div class="edit-form-grid">
                      <div class="edit-field">
                        <label class="form-label lna">{{ labels.field('basicData','deadlineDate') }} <app-tooltip text="infoRequestDeadlineDate" /></label>
                        <app-date-picker
                          [date]="basicInfoForm.get('mustCompleteByDate')?.value"
                          [dateRangeMode]="DateRangeMode.FutureAndToday"
                          (dateSelected)="onMustCompleteByDateSelected($event)" />
                      </div>
                      <div class="edit-field">
                        <label class="form-label lna">{{ labels.field('basicData','letterNumber') }}</label>
                        <input class="form-control lna" type="text" formControlName="letterNumber" maxlength="50" />
                      </div>
                    </div>

                    <div class="edit-field">
                      <label class="form-label lna">{{ labels.field('basicData','aboutSubject') }} <app-tooltip text="infoRequestAboutSubject" /></label>
                      <input class="form-control lna" type="text" formControlName="aboutSubject" maxlength="50" />
                    </div>

                    <div class="checkbox-field">
                      <input class="form-check-input lna checkbox" type="checkbox" id="requiresRestrictedAccess" formControlName="requiresRestrictedAccess" />
                      <label for="requiresRestrictedAccess">{{ labels.section('restrictedAccess') }}</label>
                      <app-tooltip text="infoRequestRestrictedAccess" />
                    </div>
                  </form>
                </div>
              } @else {
                <!-- View mode -->
                <div class="section-body">
                  <ng-container *ngTemplateOutlet="printBody; context: { $implicit: printSection('basicData') }" />
                </div>
              }
            </div>
          </div>

          <!-- Pieprasījums (collapsible) -->
          <div class="collapsible-section">
            <div class="section-header" (click)="isRequestExpanded = !isRequestExpanded" (keydown.enter)="isRequestExpanded = !isRequestExpanded" tabindex="0">
              <div class="section-header-left">
                <img [ngClass]="{ chevron: true, open: isRequestExpanded }" src="assets/images/chevron-icon.svg" alt="arrow" />
                <h5>{{ labels.section('requestContent') }}</h5>
              </div>
              <div class="section-actions" (click)="$event.stopPropagation()">
                @if (isRequestEditMode) {
                  <button class="secondary" (click)="cancelRequestEdit()">
                    {{ 'pages.viewInfoRequest.basicInfo.cancel' | translate }}
                  </button>
                  <button class="primary" [disabled]="isActionLoading || isRequestSaving" (click)="saveRequest()">
                    {{ 'pages.viewInfoRequest.basicInfo.save' | translate }}
                  </button>
                } @else if (canEditRequest) {
                  <button class="tertiary" (click)="enterRequestEdit()">
                    {{ 'pages.viewInfoRequest.edit' | translate }}
                  </button>
                }
              </div>
            </div>
            <div [ngbCollapse]="!isRequestExpanded">
              @if (isRequestEditMode) {
                <div class="section-body">
                  <app-info-request-form
                    #topicFormEdit
                    [client]="client"
                    [application]="request"
                    [topics]="topics"
                    [inlineEditMode]="true"
                    (inlineEditSaved)="onRequestSaved($event)" />

                  <div class="documents-subsection">
                    <h6 class="subsection-title">{{ labels.field('requestContent', 'documents') }}</h6>
                    <app-file-upload
                      #requestDocumentUpload
                      [existingFiles]="documentFiles"
                      [isEditMode]="true"
                      [type]="fileObjectType"
                      [associatedEntityId]="requestId"
                      [showDescription]="true"
                      [showBackofficeNote]="false"
                      [maxFiles]="10"
                      [allowToAddNewFile]="true"
                      [noPadding]="true" />
                  </div>
                </div>
              } @else {
                <div class="section-body">
                  <ng-container *ngTemplateOutlet="printBody; context: { $implicit: printSection('requestContent') }" />
                </div>
              }
            </div>
          </div>

          <!-- Klients un maksātājs (collapsible) -->
          <div class="collapsible-section">
            <div class="section-header" (click)="isClientPayerExpanded = !isClientPayerExpanded" (keydown.enter)="isClientPayerExpanded = !isClientPayerExpanded" tabindex="0">
              <div class="section-header-left">
                <img [ngClass]="{ chevron: true, open: isClientPayerExpanded }" src="assets/images/chevron-icon.svg" alt="arrow" />
                <h5>{{ labels.section('clientPayer') }}</h5>
              </div>
              <div class="section-actions" (click)="$event.stopPropagation()">
                @if (isClientPayerEditMode) {
                  <button class="secondary" (click)="cancelClientPayerEdit()">
                    {{ 'pages.viewInfoRequest.basicInfo.cancel' | translate }}
                  </button>
                  <button class="primary" [disabled]="isActionLoading" (click)="saveClientPayer()">
                    {{ 'pages.viewInfoRequest.basicInfo.save' | translate }}
                  </button>
                } @else if (canEditRequest) {
                  <button class="tertiary" (click)="enterClientPayerEdit()">
                    {{ 'pages.viewInfoRequest.edit' | translate }}
                  </button>
                }
              </div>
            </div>
            <div [ngbCollapse]="!isClientPayerExpanded">
              @if (isClientPayerEditMode) {
                <div class="section-body">
                  <app-info-request-client-payer-form
                    #clientPayerFormEdit
                    [client]="client"
                    [application]="request"
                    [selectedTopic]="selectedTopic"
                    [inlineEditMode]="true"
                    (inlineEditSaved)="onClientPayerSaved($event)" />
                </div>
              } @else {
                <div class="section-body">
                  <ng-container *ngTemplateOutlet="printBody; context: { $implicit: printSection('clientPayer') }" />
                </div>
              }
            </div>
          </div>

        } @else if (activeItem === 'infoRequestResponse') {

          <!-- 1. Atbildes dokumenta veids -->
          <div class="section">
            <div class="response-section-header">
              <div class="title-with-tooltip">
                <h5>{{ 'pages.viewInfoRequest.response.documentType' | translate }}</h5>
                <app-tooltip text="responseDocumentType" />
              </div>
              <div class="response-section-actions">
                @if (isDocumentTypeEditMode) {
                  <button class="primary" [disabled]="isActionLoading" (click)="saveDocumentTypes()">
                    {{ 'pages.viewInfoRequest.response.save' | translate }}
                  </button>
                  <button class="secondary" (click)="cancelDocumentTypeEdit()">
                    {{ 'pages.viewInfoRequest.response.cancel' | translate }}
                  </button>
                } @else if (!isResponseTabReadonly) {
                  <button class="secondary" (click)="enterDocumentTypeEdit()">
                    {{ 'pages.viewInfoRequest.response.edit' | translate }}
                  </button>
                }
              </div>
            </div>

            @if (isDocumentTypeEditMode) {
              <div class="document-type-edit mt-16">
                @for (row of documentTypeRows; track $index; let last = $last) {
                  <div class="document-type-row">
                    <div class="document-type-row-fields">
                      <div class="document-type-select">
                        <label class="form-label lna">{{ 'pages.viewInfoRequest.response.documentTypeLabel' | translate }} {{ $index + 1 }}</label>
                        <select class="form-control lna" [ngModel]="row.valueId" (ngModelChange)="onDocumentTypeKindChange($index, $event)">
                          <option value="" disabled></option>
                          @for (opt of getAvailableDocumentTypes($index); track opt.id) {
                            <option [value]="opt.id">{{ opt.name }}</option>
                          }
                        </select>
                      </div>
                      @if (isDocumentCopyValue(row.valueId)) {
                        <div class="document-type-count">
                          <label class="form-label lna">{{ 'pages.viewInfoRequest.response.count' | translate }} <span class="required-field">*</span></label>
                          <input type="number" class="form-control lna" [(ngModel)]="row.count" min="1" />
                        </div>
                      }
                    </div>
                    <button class="btn-icon-delete" (click)="removeDocumentTypeRow($index)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                  @if (!last) {
                    <hr class="document-type-divider" />
                  }
                }
                <button class="secondary add-type-btn" (click)="addDocumentTypeRow()" [disabled]="documentTypeRows.length >= documentTypeOptions.length">
                  <i class="bi bi-plus-circle"></i>
                  {{ 'pages.viewInfoRequest.response.addDocumentType' | translate }}
                </button>
              </div>
            } @else {
              <div class="document-type-view mt-16">
                @if ((request.responseDocumentTypes || []).length > 0) {
                  @for (dt of request!.responseDocumentTypes; track dt.id; let last = $last) {
                    <div class="document-type-view-row" [class.has-border]="!last">
                      <div class="document-type-view-label">
                        <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.documentTypeLabel' | translate }} {{ $index + 1 }}</p>
                        <p class="field-value">{{ dt.name }}</p>
                      </div>
                      @if (dt.count) {
                        <div class="document-type-view-count">
                          <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.count' | translate }}</p>
                          <p class="field-value">{{ dt.count }}</p>
                        </div>
                      }
                    </div>
                  }
                } @else {
                  <p class="field-value">-</p>
                }
              </div>
            }
          </div>

          <!-- 2. Atbilde -->
          <hr class="section-divider" />
          <div class="response-atbilde-block">
            <div class="response-section-header">
              <div class="title-with-tooltip">
                <h5>{{ 'pages.viewInfoRequest.response.title' | translate }}</h5>
                <app-tooltip text="responseSection" />
              </div>
              <div class="response-section-actions">
                @if (showCompleteButton) {
                  <button class="primary" [disabled]="isActionLoading" (click)="openCompleteModal()">
                    {{ 'pages.viewInfoRequest.actions.completeButton' | translate }}
                  </button>
                }
                @if (!isResponseTabReadonly) {
                  <button class="secondary" (click)="startAddOtherResponse()">
                    <i class="bi bi-plus-circle"></i>
                    {{ 'pages.viewInfoRequest.response.addOtherResponse' | translate }}
                  </button>
                }
              </div>
            </div>
            <div class="response-fields-grid mt-16">
              <div class="info-field">
                <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.clientResponseMethod' | translate }}</p>
                <p class="field-value">{{ request.responseDeliveryMethod ? getResponseDeliveryLabel() : '-' }}</p>
              </div>
              <div class="info-field">
                <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.clientVsaaChoice' | translate }}</p>
                <p class="field-value">{{ request.vsaaFlag ? ('pages.viewInfoRequest.yes' | translate) : ('pages.viewInfoRequest.no' | translate) }}</p>
              </div>
              <div class="info-field">
                <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.completionNote' | translate }}</p>
                <p class="field-value">{{ request.completionOrCancellationNote || '-' }}</p>
              </div>
              <div class="info-field">
                <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.completionDate' | translate }}</p>
                <p class="field-value">{{ request.completedOn ? formatDatetime(request.completedOn) : (request.cancelledOn ? formatDatetime(request.cancelledOn) : '-') }}</p>
              </div>
            </div>

          </div>

          <!-- 2a. Pārsūtīšanas vēstule no Nameja -->
            <div class="section">
              <div class="response-section-header">
                <div class="title-with-tooltip">
                  <h5>{{ 'pages.viewInfoRequest.response.forwardingLetter' | translate }}</h5>
                  <app-tooltip text="forwardingLetter" />
                </div>
                <div class="response-section-actions">
                  @if (request.namejsForwarding?.retrievedFileId && !isResponseTabReadonly && !isSendingBlocked) {
                    <button class="primary" [disabled]="isActionLoading" (click)="openSendEmailModal('NamejsForwarding', request.namejsForwarding!.id)">
                      {{ 'pages.viewInfoRequest.response.sendEmail' | translate }}
                    </button>
                    <button class="primary" [disabled]="isActionLoading" (click)="openSendPortalModal('NamejsForwarding', request.namejsForwarding!.id)">
                      {{ 'pages.viewInfoRequest.response.sendPortal' | translate }}
                    </button>
                    <button class="secondary" [disabled]="isActionLoading" (click)="openMarkSentModal('NamejsForwarding', request.namejsForwarding!.id)">
                      {{ 'pages.viewInfoRequest.response.markSent' | translate }}
                    </button>
                  } @else if (!request.namejsForwarding && !isResponseTabReadonly) {
                    <button class="secondary" [disabled]="isActionLoading" (click)="requestNamejsForwarding()">
                      {{ 'pages.viewInfoRequest.response.prepareForwardingLetter' | translate }}
                    </button>
                  }
                </div>
              </div>

              <div class="namejs-document-info mt-16">
                @if (request.namejsForwarding) {
                  <div class="namejs-doc-row">
                    <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.forwardingDocument' | translate }}</p>
                    @if (request.namejsForwarding.namejsExternalId) {
                      <span class="namejs-sync-icon"><i class="bi bi-arrow-repeat"></i></span>
                      <a class="link" (click)="retrieveFromNameja('ForwardingLetter')">{{ 'pages.viewInfoRequest.response.retrieveFromNameja' | translate }}</a>
                    }
                  </div>
                  @if (request.namejsForwarding.retrievedFileId && request.namejsForwarding.files && request.namejsForwarding.files.length > 0) {
                    <p class="field-value">
                      <a class="text-link" (click)="downloadNamejsFile(request.namejsForwarding.files[0])">{{ request.namejsForwarding.files[0].uploadFileName }}</a>
                      &nbsp;·&nbsp;
                      <span>{{ 'pages.viewInfoRequest.response.retrieved' | translate }} {{ formatDatetime(request.namejsForwarding.retrievedOn!, false) }}</span>
                    </p>
                  } @else {
                    <p class="field-value">-</p>
                  }
                  <div class="response-fields-grid mt-16">
                    <div class="info-field">
                      <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.documentLinkNameja' | translate }}</p>
                      <p class="field-value">
                        @if (request.namejsForwarding.namejsDocumentLink) {
                          <a class="text-link" [href]="request.namejsForwarding.namejsDocumentLink" target="_blank">{{ request.namejsForwarding.namejsDocumentLink }}</a>
                        } @else {
                          -
                        }
                      </p>
                    </div>
                    <div class="info-field">
                      <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.documentStatusNameja' | translate }} <app-tooltip text="documentStatusNameja" /></p>
                      <p class="field-value">{{ getNamejsStatusLabel(request.namejsForwarding.namejsStatus) }}</p>
                    </div>
                  </div>

                  <!-- Sending events: Namejs-polled externals only -->
                  <div class="sending-events-section mt-16">
                    <h6 class="subsection-title">{{ 'pages.viewInfoRequest.response.sendingEventsNameja' | translate }} <app-tooltip text="sendingEventsNameja" /></h6>
                    @if (namejsExternalSendingEvents(request.namejsForwarding.sendingEvents).length > 0) {
                      <table class="lna-table">
                        <thead>
                          <tr>
                            <th>{{ 'pages.viewInfoRequest.response.sendingEventsTable.date' | translate }}</th>
                            <th>{{ 'pages.viewInfoRequest.response.sendingEventsTable.type' | translate }}</th>
                            <th>{{ 'pages.viewInfoRequest.response.sendingEventsTable.address' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (evt of namejsExternalSendingEvents(request.namejsForwarding.sendingEvents); track evt.id) {
                            <tr>
                              <td>{{ formatDatetime(evt.occurredOn) }}</td>
                              <td>{{ getNamejsSendingTypeLabel(evt.namejsSendingTypeId, evt.actualDeliveryMethod) }}</td>
                              <td>{{ evt.addressDetail || '-' }}</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    } @else {
                      <p class="field-value" style="padding: 0 24px 16px;">-</p>
                    }
                  </div>

                  <!-- Sending event details (LNAEP-recorded only; Namejs-polled events appear in the summary table above) -->
                  @if (lnaepSendingEvents(request.namejsForwarding.sendingEvents).length > 0) {
                    <hr class="sending-events-divider" />
                  }
                  @for (evt of lnaepSendingEvents(request.namejsForwarding.sendingEvents); track evt.id) {
                    <div class="sending-event-detail">
                      <p class="sending-event-header">
                        {{ 'pages.viewInfoRequest.response.sendingEventNumber' | translate }} {{ evt.ordinalNumber }}
                        &nbsp;•&nbsp; <strong>{{ evt.registeredByUserName || '-' }}</strong>
                        &nbsp;•&nbsp; {{ formatDatetime(evt.occurredOn, false) }}
                      </p>
                      <div class="response-fields-grid">
                        <div class="info-field">
                          <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.actualDeliveryMethod' | translate }}</p>
                          <p class="field-value">{{ getNamejsSendingTypeLabel(evt.namejsSendingTypeId, evt.actualDeliveryMethod) }}</p>
                        </div>
                        @if (evt.addressDetail) {
                          <div class="info-field">
                            <p class="field-label-bold">
                              @if (evt.actualDeliveryMethod === 'Email') {
                                {{ 'pages.viewInfoRequest.response.emailAddress' | translate }}
                              } @else {
                                {{ 'pages.viewInfoRequest.response.addressDetail' | translate }}
                              }
                            </p>
                            <p class="field-value">{{ evt.addressDetail }}</p>
                          </div>
                        }
                      </div>
                      @if (evt.emailSubject && evt.emailSubject !== '-') {
                        <div class="info-field mt-16">
                          <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.emailSubject' | translate }}</p>
                          <p class="field-value">{{ evt.emailSubject }}</p>
                        </div>
                      }
                      @if (evt.emailBody && evt.emailBody !== '-') {
                        <div class="info-field mt-16">
                          <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.emailBody' | translate }}</p>
                          <p class="field-value">{{ evt.emailBody }}</p>
                        </div>
                      }
                      @if (evt.clientMessage) {
                        <div class="info-field mt-16">
                          <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.clientMessage' | translate }}</p>
                          <p class="field-value">{{ evt.clientMessage }}</p>
                        </div>
                      }
                      @if (evt.backofficeNote) {
                        <div class="info-field mt-16">
                          <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.lnaNotes' | translate }}</p>
                          <p class="field-value">{{ evt.backofficeNote }}</p>
                        </div>
                      }
                      @if (sendingEventFile(evt); as sentFile) {
                        <div class="info-field mt-16">
                          <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.files' | translate }}</p>
                          <a class="text-link" (click)="downloadNamejsFile(sentFile)">{{ sentFile.uploadFileName }}</a>
                        </div>
                      }
                    </div>
                  }
                } @else {
                  <div class="namejs-doc-row">
                    <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.forwardingDocument' | translate }}</p>
                  </div>
                  <p class="field-value">-</p>
                  <div class="response-fields-grid mt-16">
                    <div class="info-field">
                      <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.documentLinkNameja' | translate }}</p>
                      <p class="field-value">-</p>
                    </div>
                    <div class="info-field">
                      <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.documentStatusNameja' | translate }} <app-tooltip text="documentStatusNameja" /></p>
                      <p class="field-value">-</p>
                    </div>
                  </div>
                  <div class="sending-events-section mt-16">
                    <h6 class="subsection-title">{{ 'pages.viewInfoRequest.response.sendingEventsNameja' | translate }} <app-tooltip text="sendingEventsNameja" /></h6>
                    <p class="field-value" style="padding: 0 24px 16px;">-</p>
                  </div>
                }
              </div>
            </div>

          <!-- 2b. Atbilde no Nameja -->
          <div class="section">
              <div class="response-section-header">
                <div class="title-with-tooltip">
                  <h5>{{ 'pages.viewInfoRequest.response.namejaResponse' | translate }}</h5>
                  <app-tooltip text="namejaResponse" />
                </div>
                <div class="response-section-actions">
                  @if (request.namejsReply?.retrievedFileId && !isResponseTabReadonly && !isSendingBlocked) {
                    <button class="primary" [disabled]="isActionLoading" (click)="openSendEmailModal('NamejsReply', request.namejsReply!.id)">
                      {{ 'pages.viewInfoRequest.response.sendEmail' | translate }}
                    </button>
                    <button class="primary" [disabled]="isActionLoading" (click)="openSendPortalModal('NamejsReply', request.namejsReply!.id)">
                      {{ 'pages.viewInfoRequest.response.sendPortal' | translate }}
                    </button>
                    <button class="secondary" [disabled]="isActionLoading" (click)="openMarkSentModal('NamejsReply', request.namejsReply!.id)">
                      {{ 'pages.viewInfoRequest.response.markSent' | translate }}
                    </button>
                  } @else if (!request.namejsReply && !isResponseTabReadonly) {
                    <button class="secondary" [disabled]="isActionLoading" (click)="requestNamejsReply()">
                      {{ 'pages.viewInfoRequest.response.prepareNamejaResponse' | translate }}
                    </button>
                  }
                </div>
              </div>

              <div class="namejs-document-info mt-16">
                @if (request.namejsReply) {
                  <div class="namejs-doc-row">
                    <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.responseDocument' | translate }}</p>
                    @if (request.namejsReply.namejsExternalId) {
                      <span class="namejs-sync-icon"><i class="bi bi-arrow-repeat"></i></span>
                      <a class="link" (click)="retrieveFromNameja('Reply')">{{ 'pages.viewInfoRequest.response.retrieveFromNameja' | translate }}</a>
                    }
                  </div>
                  @if (request.namejsReply.retrievedFileId && request.namejsReply.files && request.namejsReply.files.length > 0) {
                    <p class="field-value">
                      <a class="text-link" (click)="downloadNamejsFile(request.namejsReply.files[0])">{{ request.namejsReply.files[0].uploadFileName }}</a>
                      &nbsp;·&nbsp;
                      <span>{{ 'pages.viewInfoRequest.response.retrieved' | translate }} {{ formatDatetime(request.namejsReply.retrievedOn!, false) }}</span>
                    </p>
                  } @else {
                    <p class="field-value">-</p>
                  }
                  <div class="response-fields-grid mt-16">
                    <div class="info-field">
                      <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.documentLinkNameja' | translate }}</p>
                      <p class="field-value">
                        @if (request.namejsReply.namejsDocumentLink) {
                          <a class="text-link" [href]="request.namejsReply.namejsDocumentLink" target="_blank">{{ request.namejsReply.namejsDocumentLink }}</a>
                        } @else {
                          -
                        }
                      </p>
                    </div>
                    <div class="info-field">
                      <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.documentStatusNameja' | translate }} <app-tooltip text="documentStatusNameja" /></p>
                      <p class="field-value">{{ getNamejsStatusLabel(request.namejsReply.namejsStatus) }}</p>
                    </div>
                  </div>

                  <!-- Sending events: Namejs-polled externals only -->
                  <div class="sending-events-section mt-16">
                    <h6 class="subsection-title">{{ 'pages.viewInfoRequest.response.sendingEventsNameja' | translate }} <app-tooltip text="sendingEventsNameja" /></h6>
                    @if (namejsExternalSendingEvents(request.namejsReply.sendingEvents).length > 0) {
                      <table class="lna-table">
                        <thead>
                          <tr>
                            <th>{{ 'pages.viewInfoRequest.response.sendingEventsTable.date' | translate }}</th>
                            <th>{{ 'pages.viewInfoRequest.response.sendingEventsTable.type' | translate }}</th>
                            <th>{{ 'pages.viewInfoRequest.response.sendingEventsTable.address' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (evt of namejsExternalSendingEvents(request.namejsReply.sendingEvents); track evt.id) {
                            <tr>
                              <td>{{ formatDatetime(evt.occurredOn) }}</td>
                              <td>{{ getNamejsSendingTypeLabel(evt.namejsSendingTypeId, evt.actualDeliveryMethod) }}</td>
                              <td>{{ evt.addressDetail || '-' }}</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    } @else {
                      <p class="field-value" style="padding: 0 24px 16px;">-</p>
                    }
                  </div>

                  <!-- Sending event details (LNAEP-recorded only; Namejs-polled events appear in the summary table above) -->
                  @if (lnaepSendingEvents(request.namejsReply.sendingEvents).length > 0) {
                    <hr class="sending-events-divider" />
                  }
                  @for (evt of lnaepSendingEvents(request.namejsReply.sendingEvents); track evt.id) {
                    <div class="sending-event-detail">
                      <p class="sending-event-header">
                        {{ 'pages.viewInfoRequest.response.sendingEventNumber' | translate }} {{ evt.ordinalNumber }}
                        &nbsp;•&nbsp; <strong>{{ evt.registeredByUserName || '-' }}</strong>
                        &nbsp;•&nbsp; {{ formatDatetime(evt.occurredOn, false) }}
                      </p>
                      <div class="response-fields-grid">
                        <div class="info-field">
                          <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.actualDeliveryMethod' | translate }}</p>
                          <p class="field-value">{{ getNamejsSendingTypeLabel(evt.namejsSendingTypeId, evt.actualDeliveryMethod) }}</p>
                        </div>
                        @if (evt.addressDetail) {
                          <div class="info-field">
                            <p class="field-label-bold">
                              @if (evt.actualDeliveryMethod === 'Email') {
                                {{ 'pages.viewInfoRequest.response.emailAddress' | translate }}
                              } @else {
                                {{ 'pages.viewInfoRequest.response.addressDetail' | translate }}
                              }
                            </p>
                            <p class="field-value">{{ evt.addressDetail }}</p>
                          </div>
                        }
                      </div>
                      @if (evt.emailSubject && evt.emailSubject !== '-') {
                        <div class="info-field mt-16">
                          <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.emailSubject' | translate }}</p>
                          <p class="field-value">{{ evt.emailSubject }}</p>
                        </div>
                      }
                      @if (evt.emailBody && evt.emailBody !== '-') {
                        <div class="info-field mt-16">
                          <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.emailBody' | translate }}</p>
                          <p class="field-value">{{ evt.emailBody }}</p>
                        </div>
                      }
                      @if (evt.clientMessage) {
                        <div class="info-field mt-16">
                          <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.clientMessage' | translate }}</p>
                          <p class="field-value">{{ evt.clientMessage }}</p>
                        </div>
                      }
                      @if (evt.backofficeNote) {
                        <div class="info-field mt-16">
                          <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.lnaNotes' | translate }}</p>
                          <p class="field-value">{{ evt.backofficeNote }}</p>
                        </div>
                      }
                      @if (sendingEventFile(evt); as sentFile) {
                        <div class="info-field mt-16">
                          <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.files' | translate }}</p>
                          <a class="text-link" (click)="downloadNamejsFile(sentFile)">{{ sentFile.uploadFileName }}</a>
                        </div>
                      }
                    </div>
                  }
                } @else {
                  <div class="namejs-doc-row">
                    <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.responseDocument' | translate }}</p>
                  </div>
                  <p class="field-value">-</p>
                  <div class="response-fields-grid mt-16">
                    <div class="info-field">
                      <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.documentLinkNameja' | translate }}</p>
                      <p class="field-value">-</p>
                    </div>
                    <div class="info-field">
                      <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.documentStatusNameja' | translate }} <app-tooltip text="documentStatusNameja" /></p>
                      <p class="field-value">-</p>
                    </div>
                  </div>
                  <div class="sending-events-section mt-16">
                    <h6 class="subsection-title">{{ 'pages.viewInfoRequest.response.sendingEventsNameja' | translate }} <app-tooltip text="sendingEventsNameja" /></h6>
                    <p class="field-value" style="padding: 0 24px 16px;">-</p>
                  </div>
                }
              </div>
            </div>

          <!-- 3. Atbildes sagatave -->
          <div class="section">
            <div class="response-section-header">
              <div class="title-with-tooltip">
                <h5>{{ 'pages.viewInfoRequest.response.responsePreparation' | translate }}</h5>
                <app-tooltip text="responsePreparation" />
              </div>
              <div class="response-section-actions">
                @if (canEditDrafts && !isResponseTabReadonly) {
                  <button class="secondary" (click)="startAddDraft()">
                    <i class="bi bi-plus-circle"></i>
                    {{ 'pages.viewInfoRequest.response.addNew' | translate }}
                  </button>
                }
              </div>
            </div>

            <div class="drafts-content mt-16">
              @if ((request.responseDrafts || []).length > 0 || isAddingDraft) {
                <table class="drafts-table">
                  <colgroup>
                    <col style="width: 40%" />
                    <col style="width: 15%" />
                    <col style="width: 25%" />
                    <col style="width: 20%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <td>{{ 'pages.viewInfoRequest.response.text' | translate }} <app-tooltip text="responseDraftText" /></td>
                      <td>{{ 'pages.viewInfoRequest.response.registeredBy' | translate }}</td>
                      <td>{{ 'pages.viewInfoRequest.response.files' | translate }} <app-tooltip text="responseDraftFiles" /></td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    @if (isAddingDraft) {
                      <tr class="editing-row">
                        <td>
                          <div class="textarea-wrapper">
                            <textarea
                              class="form-control lna"
                              [(ngModel)]="newDraftText"
                              [ngClass]="{ invalid: draftTouched && !newDraftText.trim() }"
                              (blur)="draftTouched = true"
                              rows="4"
                              maxlength="1000"></textarea>
                            <p class="length" [ngClass]="{ invalid: newDraftText.length > 1000 }">
                              {{ newDraftText.length }}/1000
                            </p>
                          </div>
                        </td>
                        <td>-</td>
                        <td>
                          <app-file-upload
                            [isEditMode]="true"
                            [existingFiles]="[]"
                            [type]="fileTypeResponseDraft"
                            [associatedEntityId]="newDraftId"
                            [isSubmitting]="isSubmittingNewDraftFiles"
                            [showDescription]="false"
                            [showBackofficeNote]="false"
                            (uploading)="handleNewDraftFileUploads($event)" />
                        </td>
                        <td>
                          <div class="action-btn-wrapper">
                            <button class="primary" [disabled]="!newDraftText.trim() || isActionLoading" (click)="confirmAddDraft()">
                              {{ 'pages.viewInfoRequest.response.save' | translate }}
                            </button>
                            <button class="secondary" (click)="cancelAddDraft()">
                              {{ 'pages.viewInfoRequest.response.cancel' | translate }}
                            </button>
                          </div>
                        </td>
                      </tr>
                    }
                    @for (draft of request.responseDrafts; track draft.id) {
                      @if (editingDraftId === draft.id) {
                        <tr class="editing-row">
                          <td>
                            <div class="textarea-wrapper">
                              <textarea
                                class="form-control lna"
                                [(ngModel)]="editingDraftText"
                                [ngClass]="{ invalid: editDraftTouched && !editingDraftText.trim() }"
                                (blur)="editDraftTouched = true"
                                rows="4"
                                maxlength="1000"></textarea>
                              <p class="length" [ngClass]="{ invalid: editingDraftText.length > 1000 }">
                                {{ editingDraftText.length }}/1000
                              </p>
                            </div>
                          </td>
                          <td>
                            {{ draft.createdBy || '-' }}<br/>
                            @if (draft.structuralUnitCodes.length) {
                              {{ draft.structuralUnitCodes.join(', ') }}<br/>
                            }
                            {{ formatDatetime(draft.modifiedOn || draft.createdOn) }}
                          </td>
                          <td>
                            <app-file-upload
                              [existingFiles]="draft.files || []"
                              [isEditMode]="true"
                              [isSubmitting]="isSubmittingDraftFiles"
                              [type]="fileTypeResponseDraft"
                              [associatedEntityId]="draft.id"
                              [showDescription]="false"
                              [showBackofficeNote]="false"
                              [allowToAddNewFile]="true"
                              [noPadding]="true"
                              (uploading)="handleDraftFileUploads($event)" />
                          </td>
                          <td>
                            <div class="action-btn-wrapper">
                              <button class="primary" [disabled]="!editingDraftText.trim() || isActionLoading" (click)="confirmEditDraft()">
                                {{ 'pages.viewInfoRequest.response.save' | translate }}
                              </button>
                              <button class="secondary" (click)="cancelEditDraft()">
                                {{ 'pages.viewInfoRequest.response.cancel' | translate }}
                              </button>
                            </div>
                          </td>
                        </tr>
                      } @else {
                        <tr>
                          <td>{{ draft.text }}</td>
                          <td>
                            {{ draft.createdBy || '-' }}<br/>
                            @if (draft.structuralUnitCodes.length) {
                              {{ draft.structuralUnitCodes.join(', ') }}<br/>
                            }
                            {{ formatDatetime(draft.modifiedOn || draft.createdOn) }}
                          </td>
                          <td>
                            <app-file-upload
                              [existingFiles]="draft.files || []"
                              [isEditMode]="false"
                              [isSubmitting]="false"
                              [type]="fileTypeResponseDraft"
                              [associatedEntityId]="draft.id"
                              [showDescription]="false"
                              [showBackofficeNote]="false"
                              [noPadding]="true" />
                          </td>
                          @if (canEditDrafts && !isResponseTabReadonly) {
                            <td>
                              <div class="action-btn-wrapper">
                                <button class="link" (click)="startEditDraft(draft)"><img src="assets/images/edit-icon.svg" alt="edit" />{{ 'pages.viewInfoRequest.response.edit' | translate }}</button>
                                <button class="link" (click)="deleteDraft(draft.id)"><img src="assets/images/delete-icon.svg" alt="delete" />{{ 'pages.viewInfoRequest.response.delete' | translate }}</button>
                              </div>
                            </td>
                          }
                        </tr>
                      }
                    }
                  </tbody>
                </table>
              } @else {
                <p class="field-value">-</p>
              }
            </div>
          </div>
          <!-- 4. Cita atbilde Nr. X -->
          @for (other of request.otherResponses; track other.id) {
            <div class="section">
              <div class="response-section-header">
                <div class="title-with-tooltip">
                  <h5>{{ 'pages.viewInfoRequest.response.otherResponse' | translate }} {{ other.ordinalNumber }}</h5>
                </div>
                <div class="response-section-actions">
                  @if (!isResponseTabReadonly && !isSendingBlocked) {
                    <button class="primary" [disabled]="isActionLoading" (click)="openSendEmailModal('OtherResponse', other.id)">
                      {{ 'pages.viewInfoRequest.response.sendEmail' | translate }}
                    </button>
                    <button class="primary" [disabled]="isActionLoading" (click)="openSendPortalModal('OtherResponse', other.id)">
                      {{ 'pages.viewInfoRequest.response.sendPortal' | translate }}
                    </button>
                    <button class="secondary" [disabled]="isActionLoading" (click)="openMarkSentModal('OtherResponse', other.id)">
                      {{ 'pages.viewInfoRequest.response.markSent' | translate }}
                    </button>
                  }
                </div>
              </div>
              <div class="other-response-content mt-16">
                <table class="other-response-table">
                  <colgroup>
                    <col style="width: 40%" />
                    <col style="width: 15%" />
                    <col style="width: 25%" />
                    <col style="width: 20%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <td>{{ 'pages.viewInfoRequest.response.fileDescription' | translate }}<span class="required-field">*</span></td>
                      <td>{{ 'pages.viewInfoRequest.response.registeredBy' | translate }}</td>
                      <td>{{ 'pages.viewInfoRequest.response.files' | translate }}<span class="required-field">*</span> <app-tooltip [marginBottom]="false" text="otherResponseFiles" /></td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    @if (editingOtherResponseId === other.id) {
                      <tr class="editing-row">
                        <td>
                          <div class="textarea-wrapper">
                            <textarea
                              class="form-control lna"
                              [(ngModel)]="editingOtherResponseDescription"
                              [ngClass]="{ invalid: editOtherResponseTouched && !editingOtherResponseDescription.trim() }"
                              (blur)="editOtherResponseTouched = true"
                              rows="4"
                              maxlength="255"></textarea>
                            <p class="length" [ngClass]="{ invalid: editingOtherResponseDescription.length > 255 }">
                              {{ editingOtherResponseDescription.length }}/255
                            </p>
                          </div>
                        </td>
                        <td>{{ other.createdBy || '-' }}<br/>@if (other.structuralUnitCodes.length) {{{ other.structuralUnitCodes.join(', ') }}<br/>}{{ formatDatetime(other.createdOn) }}</td>
                        <td>
                          <app-file-upload
                            #editOtherResponseFileUpload
                            [existingFiles]="other.files || []"
                            [isEditMode]="true"
                            [isSubmitting]="isSubmittingOtherResponseFiles"
                            [type]="fileTypeOtherResponse"
                            [associatedEntityId]="other.id"
                            [showDescription]="false"
                            [showBackofficeNote]="false"
                            [allowToAddNewFile]="true"
                            [noPadding]="true"
                            [disableDelete]="other.sendingEvents.length > 0"
                            [disableAddFile]="other.sendingEvents.length > 0"
                            (uploading)="handleOtherResponseFileUploads($event)" />
                        </td>
                        <td>
                          <div class="action-btn-wrapper">
                            <button class="primary" [disabled]="!editingOtherResponseDescription.trim() || isActionLoading" (click)="confirmEditOtherResponse()">
                              {{ 'pages.viewInfoRequest.response.save' | translate }}
                            </button>
                            <button class="secondary" (click)="cancelEditOtherResponse()">
                              {{ 'pages.viewInfoRequest.response.cancel' | translate }}
                            </button>
                          </div>
                        </td>
                      </tr>
                    } @else {
                      <tr>
                        <td>{{ other.description || '-' }}</td>
                        <td>{{ other.createdBy || '-' }}<br/>@if (other.structuralUnitCodes.length) {{{ other.structuralUnitCodes.join(', ') }}<br/>}{{ formatDatetime(other.createdOn) }}</td>
                        <td>
                          <app-file-upload
                            [existingFiles]="other.files || []"
                            [isEditMode]="false"
                            [isSubmitting]="false"
                            [type]="fileTypeOtherResponse"
                            [associatedEntityId]="other.id"
                            [showDescription]="false"
                            [showBackofficeNote]="false"
                            [noPadding]="true" />
                        </td>
                        @if (!isResponseTabReadonly) {
                          <td>
                            <div class="action-btn-wrapper">
                              <button class="link" (click)="startEditOtherResponse(other)"><img src="assets/images/edit-icon.svg" alt="edit" />{{ 'pages.viewInfoRequest.response.edit' | translate }}</button>
                              <button class="link" [disabled]="other.sendingEvents.length > 0" (click)="deleteOtherResponse(other.id)"><img src="assets/images/delete-icon.svg" alt="delete" />{{ 'pages.viewInfoRequest.response.delete' | translate }}</button>
                            </div>
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>

                <!-- Sending events for other response -->
                @for (evt of other.sendingEvents; track evt.id) {
                  <div class="sending-event-detail">
                    <p class="sending-event-header">
                      {{ 'pages.viewInfoRequest.response.sendingEventNumber' | translate }} {{ evt.ordinalNumber }}
                      &nbsp;•&nbsp; <strong>{{ evt.registeredByUserName || '-' }}</strong>
                      &nbsp;•&nbsp; {{ formatDatetime(evt.occurredOn, false) }}
                    </p>
                    <div class="response-fields-grid">
                      <div class="info-field">
                        <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.actualDeliveryMethod' | translate }}</p>
                        <p class="field-value">{{ getNamejsSendingTypeLabel(evt.namejsSendingTypeId, evt.actualDeliveryMethod) }}</p>
                      </div>
                      @if (evt.addressDetail) {
                        <div class="info-field">
                          <p class="field-label-bold">
                            @if (evt.actualDeliveryMethod === 'Email') {
                              {{ 'pages.viewInfoRequest.response.emailAddress' | translate }}
                            } @else {
                              {{ 'pages.viewInfoRequest.response.addressDetail' | translate }}
                            }
                          </p>
                          <p class="field-value">{{ evt.addressDetail }}</p>
                        </div>
                      }
                    </div>
                    @if (evt.emailSubject && evt.emailSubject !== '-') {
                      <div class="info-field mt-16">
                        <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.emailSubject' | translate }}</p>
                        <p class="field-value">{{ evt.emailSubject }}</p>
                      </div>
                    }
                    @if (evt.emailBody && evt.emailBody !== '-') {
                      <div class="info-field mt-16">
                        <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.emailBody' | translate }}</p>
                        <p class="field-value">{{ evt.emailBody }}</p>
                      </div>
                    }
                    @if (evt.clientMessage) {
                      <div class="info-field mt-16">
                        <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.clientMessage' | translate }}</p>
                        <p class="field-value">{{ evt.clientMessage }}</p>
                      </div>
                    }
                    @if (evt.backofficeNote) {
                      <div class="info-field mt-16">
                        <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.lnaNotes' | translate }}</p>
                        <p class="field-value">{{ evt.backofficeNote }}</p>
                      </div>
                    }
                    @if (other.files && other.files.length) {
                      <div class="info-field mt-16">
                        <p class="field-label-bold">{{ 'pages.viewInfoRequest.response.files' | translate }}</p>
                        <app-file-upload
                          [existingFiles]="other.files"
                          [isEditMode]="false"
                          [isSubmitting]="false"
                          [type]="fileTypeOtherResponse"
                          [associatedEntityId]="other.id"
                          [noPadding]="true" />
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }

          @if (isAddingOtherResponse) {
            <div class="section" id="new-other-response">
              <div class="response-section-header">
                <div class="title-with-tooltip">
                  <h5>{{ 'pages.viewInfoRequest.response.otherResponse' | translate }} {{ (request.otherResponses.length || 0) + 1 }}</h5>
                </div>
              </div>
              <div class="other-response-content mt-16">
                <table class="other-response-table">
                  <colgroup>
                    <col style="width: 40%" />
                    <col style="width: 15%" />
                    <col style="width: 25%" />
                    <col style="width: 20%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <td>{{ 'pages.viewInfoRequest.response.fileDescription' | translate }}<span class="required-field">*</span></td>
                      <td>{{ 'pages.viewInfoRequest.response.registeredBy' | translate }}</td>
                      <td>{{ 'pages.viewInfoRequest.response.files' | translate }}<span class="required-field">*</span> <app-tooltip [marginBottom]="false" text="otherResponseFiles" /></td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="editing-row">
                      <td>
                        <div class="textarea-wrapper">
                          <textarea
                            class="form-control lna"
                            [(ngModel)]="newOtherResponseDescription"
                            [ngClass]="{ invalid: otherResponseTouched && !newOtherResponseDescription.trim() }"
                            (blur)="otherResponseTouched = true"
                            rows="4"
                            maxlength="255"></textarea>
                          <p class="length" [ngClass]="{ invalid: newOtherResponseDescription.length > 255 }">
                            {{ newOtherResponseDescription.length }}/255
                          </p>
                        </div>
                      </td>
                      <td>-</td>
                      <td>
                        <app-file-upload
                          [isEditMode]="true"
                          [existingFiles]="[]"
                          [type]="fileTypeOtherResponse"
                          [associatedEntityId]="newOtherResponseId"
                          [isSubmitting]="isSubmittingNewOtherResponseFiles"
                          [showDescription]="false"
                          [showBackofficeNote]="false"
                          (filesChanged)="newOtherResponseFiles = $event.files"
                          (uploading)="handleNewOtherResponseFileUploads($event)" />
                      </td>
                      <td>
                        <div class="action-btn-wrapper">
                          <button class="primary" [disabled]="!newOtherResponseDescription.trim() || !newOtherResponseFiles.length || isActionLoading" (click)="confirmAddOtherResponse()">
                            {{ 'pages.viewInfoRequest.response.save' | translate }}
                          </button>
                          <button class="secondary" (click)="cancelAddOtherResponse()">
                            {{ 'pages.viewInfoRequest.response.cancel' | translate }}
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          }

        } @else if (activeItem === 'infoRequestCommunication' && request) {
          <app-ir-conversation
            [conversationList]="conversationList?.list ?? []"
            [informationRequest]="request!"
            (markedAsRead)="checkUnreadMessages()"
            (requestRefreshed)="onRequestRefreshed($event)"
            (messageSaved)="onMessageSaved($event)" />
        } @else if (activeItem === 'infoRequestTasks' && request) {
          <app-ir-tasks
            [informationRequest]="request!"
            [tasks]="taskList"
            [minExecutionOrder]="minTaskExecutionOrder"
            [isTaskCreationDisabled]="isTaskCreationDisabled"
            [structuralUnits]="structuralUnits"
            [canEditCoResponsible]="!isTaskCreationDisabled"
            (taskCreated)="onTaskCreated($event)"
            (taskStatusChanged)="onTaskStatusChanged()"
            (requestUpdated)="onRequestUpdated($event)" />
        } @else if (activeItem === 'infoRequestInvoice' && request) {
          <app-ir-invoice
            [informationRequest]="request!"
            [calculations]="irCalculations"
            [invoices]="irInvoices"
            [structuralUnits]="structuralUnits"
            (invoiceChanged)="onInvoiceChanged()" />
        } @else if (activeItem === 'infoRequestProcessNotes') {
          <div class="section">
            <div class="response-section-header">
              <div class="title-with-tooltip">
                <h5>{{ 'pages.serviceProcessing.processNotes.title' | translate }}</h5>
                <app-tooltip text="readingRoomSubmissionNotes" />
              </div>
              <div class="response-section-actions">
                <button class="secondary" (click)="startAddNote()">
                  <i class="bi bi-plus-circle"></i>
                  {{ 'components.updateClientNoteItem.add' | translate }}
                </button>
              </div>
            </div>

            <div class="drafts-content mt-16">
              @if ((notes || []).length > 0 || isAddingNote) {
                <table class="drafts-table">
                  <colgroup>
                    <col style="width: 40%" />
                    <col style="width: 15%" />
                    <col style="width: 25%" />
                    <col style="width: 20%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <td>{{ 'pages.client.notes.table.text' | translate }}</td>
                      <td>{{ 'pages.client.notes.table.registrationInfo' | translate }}</td>
                      <td>{{ 'pages.client.notes.table.files' | translate }}</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    @if (isAddingNote) {
                      <tr class="editing-row">
                        <td>
                          <div class="textarea-wrapper">
                            <textarea class="form-control lna" [(ngModel)]="newNoteText" rows="4" maxlength="255"></textarea>
                            <p class="length" [ngClass]="{ invalid: newNoteText.length > 255 }">
                              {{ newNoteText.length }}/255
                            </p>
                          </div>
                        </td>
                        <td>-</td>
                        <td>
                          <app-file-upload
                            [isEditMode]="true"
                            [existingFiles]="[]"
                            [type]="fileTypeSubmissionNote"
                            [associatedEntityId]="newNoteId"
                            [isSubmitting]="isSubmittingNewNoteFiles"
                            [showDescription]="false"
                            [showBackofficeNote]="false"
                            (uploading)="handleNewNoteFileUploads($event)" />
                        </td>
                        <td>
                          <div class="action-btn-wrapper">
                            <button class="primary" [disabled]="!newNoteText.trim() || isActionLoading" (click)="confirmAddNote()">
                              {{ 'pages.viewInfoRequest.response.save' | translate }}
                            </button>
                            <button class="secondary" (click)="cancelAddNote()">
                              {{ 'pages.viewInfoRequest.response.cancel' | translate }}
                            </button>
                          </div>
                        </td>
                      </tr>
                    }
                    @for (note of notes; track note.id) {
                      @if (editingNoteId === note.id) {
                        <tr class="editing-row">
                          <td>
                            <div class="textarea-wrapper">
                              <textarea class="form-control lna" [(ngModel)]="editingNoteText" rows="4" maxlength="255"></textarea>
                              <p class="length" [ngClass]="{ invalid: editingNoteText.length > 255 }">
                                {{ editingNoteText.length }}/255
                              </p>
                            </div>
                          </td>
                          <td>
                            {{ note.user.firstName }} {{ note.user.lastName }}<br/>
                            @if (note.user.structuralUnitCodes.length) {
                              {{ note.user.structuralUnitCodes.join(', ') }}<br/>
                            }
                            {{ formatDatetime(note.createdOn) }}
                          </td>
                          <td>
                            <app-file-upload
                              #editNoteFileUpload
                              [existingFiles]="note.informationRequestNoteFiles || []"
                              [isEditMode]="true"
                              [isSubmitting]="isSubmittingNoteFiles"
                              [type]="fileTypeSubmissionNote"
                              [associatedEntityId]="note.id"
                              [showDescription]="false"
                              [showBackofficeNote]="false"
                              [allowToAddNewFile]="true"
                              [noPadding]="true"
                              (uploading)="handleEditNoteFileUploads($event)" />
                          </td>
                          <td>
                            <div class="action-btn-wrapper">
                              <button class="primary" [disabled]="!editingNoteText.trim() || isActionLoading" (click)="confirmEditNote()">
                                {{ 'pages.viewInfoRequest.response.save' | translate }}
                              </button>
                              <button class="secondary" (click)="cancelEditNote()">
                                {{ 'pages.viewInfoRequest.response.cancel' | translate }}
                              </button>
                            </div>
                          </td>
                        </tr>
                      } @else {
                        <tr>
                          <td>{{ note.text }}</td>
                          <td>
                            {{ note.user.firstName }} {{ note.user.lastName }}<br/>
                            @if (note.user.structuralUnitCodes.length) {
                              {{ note.user.structuralUnitCodes.join(', ') }}<br/>
                            }
                            {{ formatDatetime(note.createdOn) }}
                          </td>
                          <td>
                            <app-file-upload
                              [existingFiles]="note.informationRequestNoteFiles || []"
                              [isEditMode]="false"
                              [isSubmitting]="false"
                              [type]="fileTypeSubmissionNote"
                              [associatedEntityId]="note.id"
                              [showDescription]="false"
                              [showBackofficeNote]="false"
                              [noPadding]="true" />
                          </td>
                          <td>
                            @if (note.userId === currentUserId) {
                              <div class="action-btn-wrapper">
                                <button class="link" (click)="startEditNote(note)"><img src="assets/images/edit-icon.svg" alt="edit" />{{ 'pages.viewInfoRequest.response.edit' | translate }}</button>
                                <button class="link" (click)="confirmDeleteNote(note.id)"><img src="assets/images/delete-icon.svg" alt="delete" />{{ 'pages.viewInfoRequest.response.delete' | translate }}</button>
                              </div>
                            }
                          </td>
                        </tr>
                      }
                    }
                  </tbody>
                </table>
              } @else {
                <p class="no-notes">{{ 'pages.client.notes.noNotes' | translate }}</p>
              }
            </div>
          </div>
        } @else if (activeItem === 'infoRequestProcessHistory' && request) {
          <app-ir-process-history [informationRequest]="request!" />
        } @else if (activeItem === 'infoRequestDocuments') {
          <div class="section">
            <div class="response-section-header">
              <div class="title-with-tooltip">
                <h5>{{ 'pages.viewInfoRequest.documents.title' | translate }}</h5>
                <app-tooltip [marginBottom]="false" text="documentsTable" />
              </div>
              <div class="response-section-actions">
                <button class="secondary" (click)="startAddDocument()">
                  <i class="bi bi-file-earmark-arrow-up"></i>
                  {{ 'pages.viewInfoRequest.documents.addFile' | translate }}
                </button>
              </div>
            </div>
            <div class="other-response-content mt-16">
              <table class="other-response-table">
                <colgroup>
                  <col style="width: 35%" />
                  <col style="width: 20%" />
                  <col style="width: 25%" />
                  <col style="width: 20%" />
                </colgroup>
                <thead>
                  <tr>
                    <td>{{ 'pages.viewInfoRequest.documents.fileDescription' | translate }}</td>
                    <td>{{ 'pages.viewInfoRequest.documents.registeredBy' | translate }}</td>
                    <td>{{ 'pages.viewInfoRequest.documents.files' | translate }}</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  @if (isAddingDocument) {
                    <tr class="editing-row">
                      <td>
                        <div class="textarea-wrapper">
                          <textarea
                            class="form-control lna"
                            [(ngModel)]="newDocumentDescription"
                            [ngClass]="{ invalid: newDocumentTouched && !newDocumentDescription.trim() }"
                            (blur)="newDocumentTouched = true"
                            rows="3"
                            [maxlength]="MAX_DOCUMENT_DESCRIPTION_LENGTH"></textarea>
                          <p class="length" [ngClass]="{ invalid: newDocumentDescription.length > MAX_DOCUMENT_DESCRIPTION_LENGTH }">
                            {{ newDocumentDescription.length }}/{{ MAX_DOCUMENT_DESCRIPTION_LENGTH }}
                          </p>
                        </div>
                      </td>
                      <td>-</td>
                      <td>
                          <ngx-dropzone class="lna-dropzone" (change)="onNewDocumentFileAdded($event)" [multiple]="false">
                          <ngx-dropzone-label>
                            <span class="dropzone-label">
                              {{ 'pages.client.readersCard.uploadFile' | translate }}
                            </span>
                          </ngx-dropzone-label>
                        </ngx-dropzone>
                        @if (newDocumentFile) {
                          <div class="selected-file mt-8">
                            <img src="/assets/images/file-icon.svg" alt="file icon" class="file-icon" />
                            <span class="file-name">{{ newDocumentFile.name }}</span>
                            <button (click)="removeNewDocumentFile()">
                              <img src="assets/images/remove-file.svg" alt="remove" />
                            </button>
                          </div>
                        }
                      </td>
                      <td>
                        <div class="action-btn-wrapper">
                          <button class="primary" [disabled]="!newDocumentFile || isActionLoading" (click)="confirmAddDocument()">
                            {{ 'pages.viewInfoRequest.documents.confirm' | translate }}
                          </button>
                          <button class="secondary" (click)="cancelAddDocument()">
                            {{ 'pages.viewInfoRequest.documents.cancel' | translate }}
                          </button>
                        </div>
                      </td>
                    </tr>
                  }
                  @for (doc of irDocuments; track doc.files[0].outerId) {
                    @if (editingDocumentOuterId === doc.files[0].outerId) {
                      <tr class="editing-row">
                        <td>
                          <div class="textarea-wrapper">
                            <textarea
                              class="form-control lna"
                              [(ngModel)]="editingDocumentDescription"
                              [ngClass]="{ invalid: editDocumentTouched && !editingDocumentDescription.trim() }"
                              (blur)="editDocumentTouched = true"
                              rows="3"
                              [maxlength]="editingDocumentMaxLength"></textarea>
                            <p class="length" [ngClass]="{ invalid: editingDocumentDescription.length > editingDocumentMaxLength }">
                              {{ editingDocumentDescription.length }}/{{ editingDocumentMaxLength }}
                            </p>
                          </div>
                        </td>
                        <td class="registered-by-cell">{{ getDocumentRegisteredByDisplay(doc) }}</td>
                        <td>
                          @for (file of doc.files; track file.outerId) {
                            <div class="file-row">
                              <a class="file-link" (click)="downloadDocumentFile(file)">
                                <i class="bi bi-file-earmark"></i>
                                {{ file.uploadFileName }}
                              </a>
                              @if (doc.isDeletable) {
                                <button class="link" (click)="confirmDeleteDocument(file.outerId)">
                                  <img src="assets/images/delete-icon.svg" alt="delete" />
                                </button>
                              }
                            </div>
                          }
                        </td>
                        <td>
                          <div class="action-btn-wrapper">
                            <button class="primary" [disabled]="!editingDocumentDescription.trim() || isActionLoading" (click)="confirmEditDocument()">
                              {{ 'pages.viewInfoRequest.documents.confirm' | translate }}
                            </button>
                            <button class="secondary" (click)="cancelEditDocument()">
                              {{ 'pages.viewInfoRequest.documents.cancel' | translate }}
                            </button>
                          </div>
                        </td>
                      </tr>
                    } @else {
                      <tr>
                        <td>{{ getDocumentDescription(doc) }}</td>
                        <td class="registered-by-cell">{{ getDocumentRegisteredByDisplay(doc) }}</td>
                        <td>
                          @for (file of doc.files; track file.outerId) {
                            <div class="file-row">
                              <a class="file-link" (click)="downloadDocumentFile(file)">
                                <i class="bi bi-file-earmark"></i>
                                {{ file.uploadFileName }}
                              </a>
                              @if (doc.isDeletable) {
                                <button class="link" (click)="confirmDeleteDocument(file.outerId)">
                                  <img src="assets/images/delete-icon.svg" alt="delete" />
                                </button>
                              }
                            </div>
                          }
                        </td>
                        <td>
                          @if (doc.isDescriptionEditable) {
                            <div class="action-btn-wrapper">
                              <button class="link" (click)="startEditDocument(doc)">
                                <img src="assets/images/edit-icon.svg" alt="edit" />
                                {{ 'pages.viewInfoRequest.documents.edit' | translate }}
                              </button>
                            </div>
                          }
                        </td>
                      </tr>
                    }
                  } @empty {
                    @if (!isAddingDocument) {
                      <tr>
                        <td colspan="4" class="empty-state">{{ 'pages.viewInfoRequest.documents.noDocuments' | translate }}</td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>

<!-- Start Processing Modal -->
<ng-template #startProcessingModal let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title">{{ 'pages.viewInfoRequest.actions.startProcessingTitle' | translate }}</h4>
    <button class="btn-close" (click)="cancelStartProcessing()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <form [formGroup]="startProcessingForm">
      <div class="lna-row-32 full-width">
        <div class="label-wrapper">
          <label class="form-label lna">
            {{ 'pages.viewInfoRequest.actions.deadlineDate' | translate }}
            <span class="required-field">*</span>
          </label>
        </div>
        <app-date-picker
          [dateRangeMode]="DateRangeMode.FutureAndToday"
          (dateSelected)="onDeadlineDateSelected($event)" />
      </div>
    </form>
  </div>
  <div class="lna-modal-footer">
    <button
      class="primary"
      [disabled]="!startProcessingForm.valid || isActionLoading"
      (click)="confirmStartProcessing()">
      {{ 'pages.viewInfoRequest.actions.confirm' | translate }}
    </button>
    <button class="secondary" (click)="cancelStartProcessing()">
      {{ 'pages.viewInfoRequest.actions.cancel' | translate }}
    </button>
  </div>
</ng-template>

<!-- Complete Modal -->
<ng-template #completeModal let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="modal-title-with-tooltip">
      <h4 class="modal-title" ngbAutofocus>{{ 'pages.viewInfoRequest.actions.completeTitle' | translate }}</h4>
      <app-tooltip text="completeInfoRequest" />
    </div>
    <button class="btn-close" (click)="cancelCompleteModal()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <p>{{ 'pages.viewInfoRequest.actions.completeQuestion' | translate }}</p>
    <form [formGroup]="completeForm">
      <div class="textarea-wrapper mt-16">
        <label class="form-label lna">{{ 'pages.viewInfoRequest.actions.completeNote' | translate }}</label>
        <textarea
          class="form-control lna"
          formControlName="note"
          [maxLength]="MAX_NOTE_LENGTH"
          rows="3"></textarea>
        <p class="length" [class.invalid]="(completeForm.get('note')?.value?.length || 0) > MAX_NOTE_LENGTH">
          {{ completeForm.get('note')?.value?.length || 0 }}/{{ MAX_NOTE_LENGTH }}
        </p>
      </div>
    </form>
  </div>
  <div class="lna-modal-footer">
    <button
      class="primary"
      [disabled]="isActionLoading"
      (click)="confirmComplete()">
      {{ 'pages.viewInfoRequest.actions.complete' | translate }}
    </button>
    <button class="secondary" (click)="cancelCompleteModal()">
      {{ 'pages.viewInfoRequest.actions.cancel' | translate }}
    </button>
  </div>
</ng-template>

<!-- Cancel (Anulēt) Modal -->
<ng-template #cancelModal let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="modal-title-with-tooltip">
      <h4 class="modal-title" ngbAutofocus>{{ 'pages.viewInfoRequest.actions.annulTitle' | translate }}</h4>
      <app-tooltip text="annulInfoRequest" />
    </div>
    <button class="btn-close" (click)="cancelCancelModal()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <p>{{ 'pages.viewInfoRequest.actions.annulQuestion' | translate }}</p>
    <form [formGroup]="cancelForm">
      <div class="textarea-wrapper mt-16">
        <label class="form-label lna">
          {{ 'pages.viewInfoRequest.actions.annulNote' | translate }}
          <span class="required-field">*</span>
        </label>
        <textarea
          class="form-control lna"
          [class.invalid]="cancelForm.get('note')?.touched && cancelForm.get('note')?.invalid"
          formControlName="note"
          [maxLength]="MAX_NOTE_LENGTH"
          rows="3"></textarea>
        <p class="length" [class.invalid]="(cancelForm.get('note')?.value?.length || 0) > MAX_NOTE_LENGTH">
          {{ cancelForm.get('note')?.value?.length || 0 }}/{{ MAX_NOTE_LENGTH }}
        </p>
      </div>
    </form>
  </div>
  <div class="lna-modal-footer">
    <button
      class="primary"
      [disabled]="cancelForm.invalid || isActionLoading"
      (click)="confirmCancel()">
      {{ 'pages.viewInfoRequest.actions.annulConfirm' | translate }}
    </button>
    <button class="secondary" (click)="cancelCancelModal()">
      {{ 'pages.viewInfoRequest.actions.cancel' | translate }}
    </button>
  </div>
</ng-template>

<!-- Forward to structural unit Modal -->
<ng-template #forwardModal let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="modal-title-with-tooltip">
      <h4 class="modal-title" ngbAutofocus>{{ 'pages.viewInfoRequest.actions.forwardTitle' | translate }}</h4>
      <app-tooltip text="forwardInfoRequest" />
    </div>
    <button class="btn-close" (click)="modalService.dismissAll(); forwardForm.reset()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <form [formGroup]="forwardForm">
      <div class="lna-row-32 full-width">
        <label class="form-label lna">
          {{ 'pages.viewInfoRequest.actions.forwardTargetUnit' | translate }}
          <span class="required-field">*</span>
        </label>
        <select
          class="form-control lna"
          [class.invalid]="forwardForm.get('targetStructuralUnitId')?.touched && forwardForm.get('targetStructuralUnitId')?.invalid"
          formControlName="targetStructuralUnitId">
          <option value="" disabled>{{ 'pages.viewInfoRequest.actions.forwardSelectUnit' | translate }}</option>
          @for (unit of forwardStructuralUnitOptions; track unit.id) {
            <option [value]="unit.id">{{ unit.name }}</option>
          }
        </select>
      </div>
      <div class="textarea-wrapper mt-16">
        <label class="form-label lna">
          {{ 'pages.viewInfoRequest.actions.forwardJustification' | translate }}
        </label>
        <textarea
          class="form-control lna"
          formControlName="justification"
          [maxLength]="MAX_NOTE_LENGTH"
          rows="3"></textarea>
        <p class="length" [class.invalid]="(forwardForm.get('justification')?.value?.length || 0) > MAX_NOTE_LENGTH">
          {{ forwardForm.get('justification')?.value?.length || 0 }}/{{ MAX_NOTE_LENGTH }}
        </p>
      </div>
    </form>
  </div>
  <div class="lna-modal-footer">
    <button
      class="primary"
      [disabled]="forwardForm.invalid || isActionLoading"
      (click)="confirmForward()">
      {{ 'pages.viewInfoRequest.actions.forwardConfirm' | translate }}
    </button>
    <button class="secondary" (click)="modalService.dismissAll(); forwardForm.reset()">
      {{ 'pages.viewInfoRequest.actions.cancel' | translate }}
    </button>
  </div>
</ng-template>

<!-- Hand over to employee Modal -->
<ng-template #handOverModal let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="modal-title-with-tooltip">
      <h4 class="modal-title" ngbAutofocus>{{ 'pages.viewInfoRequest.actions.handOverTitle' | translate }}</h4>
      <app-tooltip text="handOverInfoRequest" />
    </div>
    <button class="btn-close" (click)="modalService.dismissAll(); handOverForm.reset()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <form [formGroup]="handOverForm">
      <div class="lna-row-32 full-width">
        <label class="form-label lna">
          {{ 'pages.viewInfoRequest.actions.handOverTargetUser' | translate }}
          <span class="required-field">*</span>
        </label>
        <app-search-user-input
          [invalid]="handOverForm.get('targetUserId')?.touched && handOverForm.get('targetUserId')?.invalid ? true : false"
          [disabledUsersOptions]="request?.responsibleUserId ? [request!.responsibleUserId!] : []"
          [structuralUnitId]="request?.responsibleStructuralUnitId"
          (userSelected)="onHandOverUserSelected($event)" />
      </div>
      <div class="textarea-wrapper mt-16">
        <label class="form-label lna">
          {{ 'pages.viewInfoRequest.actions.handOverJustification' | translate }}
          <span class="required-field">*</span>
        </label>
        <textarea
          class="form-control lna"
          [class.invalid]="handOverForm.get('justification')?.touched && handOverForm.get('justification')?.invalid"
          formControlName="justification"
          [maxLength]="MAX_NOTE_LENGTH"
          rows="3"></textarea>
        <p class="length" [class.invalid]="(handOverForm.get('justification')?.value?.length || 0) > MAX_NOTE_LENGTH">
          {{ handOverForm.get('justification')?.value?.length || 0 }}/{{ MAX_NOTE_LENGTH }}
        </p>
      </div>
    </form>
  </div>
  <div class="lna-modal-footer">
    <button
      class="primary"
      [disabled]="handOverForm.invalid || isActionLoading"
      (click)="confirmHandOver()">
      {{ 'pages.viewInfoRequest.actions.handOverConfirm' | translate }}
    </button>
    <button class="secondary" (click)="modalService.dismissAll(); handOverForm.reset()">
      {{ 'pages.viewInfoRequest.actions.cancel' | translate }}
    </button>
  </div>
</ng-template>

<!-- Select Structural Unit Modal -->
<app-select-structural-unit-modal
  [isOpen]="isSelectStructuralUnitModalOpen"
  [units]="userStructuralUnits"
  titleKey="pages.viewInfoRequest.actions.selectStructuralUnitTitle"
  descriptionKey="pages.viewInfoRequest.actions.selectStructuralUnitDescription"
  (confirm)="confirmSelectStructuralUnit($event)"
  (cancel)="cancelSelectStructuralUnit()" />


<!-- Send Email Modal -->
<ng-template #sendEmailModal let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="modal-title-with-tooltip">
      <h4 class="modal-title" ngbAutofocus>{{ 'pages.viewInfoRequest.response.sendEmailModal.title' | translate }}</h4>
      <app-tooltip text="sendEmail" />
    </div>
    <button class="btn-close" (click)="modalService.dismissAll()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <form [formGroup]="sendEmailForm" class="email-form-grid">
      <div class="lna-row-32 email-field-half">
        <label class="form-label lna">
          {{ 'pages.viewInfoRequest.response.sendEmailModal.recipient' | translate }}
          <span class="required-field">*</span>
        </label>
        <input type="text" class="form-control lna" formControlName="addressDetail" />
      </div>
      <div class="lna-row-32 full-width">
        <label class="form-label lna">
          {{ 'pages.viewInfoRequest.response.sendEmailModal.emailSubject' | translate }}
          <span class="required-field">*</span>
        </label>
        <input type="text" class="form-control lna" formControlName="emailSubject" />
      </div>
      <div class="lna-row-32 full-width">
        <label class="form-label lna">
          {{ 'pages.viewInfoRequest.response.sendEmailModal.emailBody' | translate }}
          <span class="required-field">*</span>
        </label>
        <div class="textarea-wrapper">
          <textarea class="form-control lna" formControlName="emailBody" rows="8" [maxLength]="MAX_BODY_LENGTH"></textarea>
          <p class="length" [ngClass]="{ invalid: sendEmailForm.get('emailBody')?.value?.length > MAX_BODY_LENGTH }">
            {{ sendEmailForm.get('emailBody')?.value?.length || 0 }}/{{ MAX_BODY_LENGTH }}
          </p>
        </div>
      </div>
      @if (sendEmailExistingFiles.length > 0) {
        <div class="lna-row-32 value-wrapper file-list">
          <label class="form-label lna">{{ 'pages.viewInfoRequest.response.sendEmailModal.attachments' | translate }}</label>
          <app-file-upload
            [isEditMode]="false"
            [existingFiles]="sendEmailExistingFiles"
            [type]="fileTypeOtherResponse"
            [associatedEntityId]="requestId"
            [isSubmitting]="false"
            [showDescription]="false" />
        </div>
      }
    </form>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="sendEmailForm.invalid || isActionLoading" (click)="confirmSendEmail()">
      {{ 'pages.viewInfoRequest.response.sendEmailModal.send' | translate }}
    </button>
    <button class="secondary" (click)="modalService.dismissAll()">
      {{ 'pages.viewInfoRequest.response.cancel' | translate }}
    </button>
  </div>
</ng-template>

<!-- Send Portal Modal -->
<ng-template #sendPortalModal let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="modal-title-with-tooltip">
      <h4 class="modal-title" ngbAutofocus>{{ 'pages.viewInfoRequest.response.sendPortalModal.title' | translate }}</h4>
      <app-tooltip text="responseSendPortal" />
    </div>
    <button class="btn-close" (click)="modalService.dismissAll()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <form [formGroup]="sendPortalForm">
      <div class="lna-row-32 full-width">
        <label class="form-label lna">{{ 'pages.viewInfoRequest.response.sendPortalModal.clientMessage' | translate }}</label>
        <div class="textarea-wrapper">
          <textarea class="form-control lna" formControlName="clientMessage" rows="4" [maxLength]="MAX_NOTE_LENGTH"></textarea>
          <p class="length" [ngClass]="{ invalid: sendPortalForm.get('clientMessage')?.value?.length > MAX_NOTE_LENGTH }">
            {{ sendPortalForm.get('clientMessage')?.value?.length || 0 }}/{{ MAX_NOTE_LENGTH }}
          </p>
        </div>
      </div>
      @if (sendPortalExistingFiles.length > 0) {
        <div class="lna-row-32 value-wrapper file-list">
          <app-file-upload
            [isEditMode]="false"
            [existingFiles]="sendPortalExistingFiles"
            [type]="fileTypeOtherResponse"
            [associatedEntityId]="requestId"
            [isSubmitting]="false"
            [showDescription]="false" />
        </div>
      }
    </form>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="isActionLoading" (click)="confirmSendPortal()">
      {{ 'pages.viewInfoRequest.response.sendPortalModal.send' | translate }}
    </button>
    <button class="secondary" (click)="modalService.dismissAll()">
      {{ 'pages.viewInfoRequest.response.cancel' | translate }}
    </button>
  </div>
</ng-template>

<!-- Mark Sent Modal -->
<ng-template #markSentModal let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="modal-title-with-tooltip">
      <h4 class="modal-title" ngbAutofocus>{{ 'pages.viewInfoRequest.response.markSentModal.titleResponse' | translate }}</h4>
      <app-tooltip text="responseMarkSent" />
    </div>
    <button class="btn-close" (click)="modalService.dismissAll()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <form [formGroup]="markSentForm">
      <div class="lna-row-32 full-width">
        <label class="form-label lna">
          {{ 'pages.viewInfoRequest.response.markSentModal.deliveryMethodResponse' | translate }}
          <span class="required-field">*</span>
        </label>
        <select class="form-control lna email-field-half" formControlName="actualDeliveryMethod">
          <option value="" disabled></option>
          @for (opt of getMarkSentDeliveryOptions(); track opt.value) {
            <option [value]="opt.value">{{ opt.label | translate }}</option>
          }
        </select>
      </div>
      @if (markSentForm.get('actualDeliveryMethod')?.value === 'Email') {
        <div class="lna-row-32 full-width mt-16">
          <label class="form-label lna">
            {{ 'pages.viewInfoRequest.response.emailAddress' | translate }}
            <span class="required-field">*</span>
          </label>
          <input type="text" class="form-control lna"
            [ngClass]="{ 'is-invalid': markSentForm.get('addressDetail')?.invalid && markSentForm.get('addressDetail')?.touched }"
            formControlName="addressDetail" />
          @if (markSentForm.get('addressDetail')?.invalid && markSentForm.get('addressDetail')?.touched) {
            <p class="error-message">{{ 'components.form.invalidEmail' | translate }}</p>
          }
        </div>
      }
      @if (markSentForm.get('actualDeliveryMethod')?.value === 'PostalMail') {
        <div class="lna-row-32 full-width mt-16">
          <label class="form-label lna">
            {{ 'pages.viewInfoRequest.response.markSentModal.address' | translate }}
          </label>
          <input type="text" class="form-control lna" formControlName="addressDetail" />
        </div>
      }
      @if (markSentForm.get('actualDeliveryMethod')?.value === 'Archive') {
        <div class="lna-row-32 full-width mt-16">
          <label class="form-label lna">{{ 'pages.viewInfoRequest.response.markSentModal.archive' | translate }}</label>
          <select class="form-control lna" formControlName="addressDetail">
            <option value="" disabled></option>
            @for (unit of structuralUnits; track unit.id) {
              <option [value]="unit.name">{{ unit.name }}</option>
            }
          </select>
        </div>
      }
      @if (markSentForm.get('actualDeliveryMethod')?.value) {
        <div class="lna-row-32 full-width mt-16">
          <label class="form-label lna">{{ 'pages.viewInfoRequest.response.markSentModal.notes' | translate }}</label>
          <div class="textarea-wrapper">
            <textarea class="form-control lna" formControlName="backofficeNote" rows="3" [maxLength]="MAX_NOTE_LENGTH"></textarea>
            <p class="length" [ngClass]="{ invalid: markSentForm.get('backofficeNote')?.value?.length > MAX_NOTE_LENGTH }">
              {{ markSentForm.get('backofficeNote')?.value?.length || 0 }}/{{ MAX_NOTE_LENGTH }}
            </p>
          </div>
        </div>
      }
    </form>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="markSentForm.invalid || isActionLoading" (click)="confirmMarkSent()">
      {{ 'pages.viewInfoRequest.response.markSentModal.save' | translate }}
    </button>
    <button class="secondary" (click)="modalService.dismissAll()">
      {{ 'pages.viewInfoRequest.response.cancel' | translate }}
    </button>
  </div>
</ng-template>

<!-- Add Draft Modal -->
<ng-template #addDraftModal let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="modal-title-with-tooltip">
      <h4 class="modal-title" ngbAutofocus>{{ 'pages.viewInfoRequest.response.addDraftModal.title' | translate }}</h4>
      <app-tooltip text="responsePreparation" />
    </div>
    <button class="btn-close" (click)="modalService.dismissAll()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <div class="lna-row-32 full-width">
      <label class="form-label lna">
        {{ 'pages.viewInfoRequest.response.addDraftModal.text' | translate }}
        <span class="required-field">*</span>
      </label>
      <textarea class="form-control lna" [(ngModel)]="newDraftText" rows="4" maxlength="1000"></textarea>
    </div>
    <div class="dropzone-wrapper">
      <ngx-dropzone class="lna-dropzone" (change)="onDraftFilesSelected($event)">
        <ngx-dropzone-label>
          <span class="dropzone-label">
            {{ 'pages.viewInfoRequest.response.addDraftModal.addFiles' | translate }}
          </span>
        </ngx-dropzone-label>
      </ngx-dropzone>
    </div>
    @if (newDraftFiles.length > 0) {
      <div class="file-list">
        @for (file of newDraftFiles; track file.name; let i = $index) {
          <div class="file">
            <img class="file-icon" src="assets/images/file-icon.svg" alt="file" />
            <p class="file-name">{{ file.name }}</p>
            <button (click)="removeDraftFile(i)" type="button">
              <img src="assets/images/remove-file.svg" alt="remove" />
            </button>
          </div>
        }
      </div>
    }
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="!newDraftText.trim() || isActionLoading" (click)="confirmAddDraft()">
      {{ 'pages.viewInfoRequest.response.addDraftModal.add' | translate }}
    </button>
    <button class="secondary" (click)="modalService.dismissAll()">
      {{ 'pages.viewInfoRequest.response.cancel' | translate }}
    </button>
  </div>
</ng-template>
<app-confirm-modal
  [isOpen]="isConfirmDeleteNoteOpen"
  (confirm)="deleteNote(noteToDeleteId!)"
  (cancel)="onDeleteNoteModalClose()"
  title="deleteClientNote" />
<app-confirm-modal
  [isOpen]="isConfirmDeleteDocumentOpen"
  (confirm)="deleteDocument(documentToDeleteOuterId!)"
  (cancel)="onDeleteDocumentModalClose()"
  title="deleteIrDocument"
  bodyText="deleteIrDocumentBody" />
<app-confirm-modal
  [isOpen]="isUnsavedChangesModalOpen"
  (confirm)="confirmDiscardChanges()"
  (cancel)="cancelDiscardChanges()"
  title="unsavedChanges"
  bodyText="unsavedChangesBody"
  confirmText="continue"
  denyText="cancelBack" />
<app-ir-request-info-modal
  [isOpen]="isRequestAdditionalInfoModalOpen"
  [informationRequest]="request!"
  (cancel)="isRequestAdditionalInfoModalOpen = false"
  (update)="onMessageSaved($event)" />

<ng-template #printBody let-section>
  @for (block of section?.blocks ?? []; track block.key) {
    @if (block.title) {
      <div class="subsection">
        <h6 class="subsection-title">
          {{ block.title }}
          @if (block.tooltipKey) {
            <app-tooltip [text]="block.tooltipKey" />
          }
        </h6>
        <ng-container *ngTemplateOutlet="printItemList; context: { $implicit: printItems(block, section.key) }" />
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="printItemList; context: { $implicit: printItems(block, section.key) }" />
    }
  }
</ng-template>

<ng-template #printItemList let-items>
  @for (item of items; track $index) {
    @switch (item.kind) {
      @case ('fields') {
        <div [ngClass]="item.grid === 'basic' ? 'basic-info-grid' : 'info-grid-2col'">
          @for (line of item.lines; track $index) {
            <div [ngClass]="printFieldClass(line)">
              <p [ngClass]="item.grid === 'basic' ? 'form-label lna' : 'field-label-bold'">
                {{ line.label }}
                @if (line.tooltipKey) {
                  <app-tooltip [text]="line.tooltipKey" />
                }
              </p>
              @if (printLink(line); as link) {
                <p class="field-value"><a class="client-link" [routerLink]="link">{{ line.value }}</a></p>
              } @else {
                <p class="field-value">{{ line.value }}</p>
              }
            </div>
          }
        </div>
      }
      @case ('card') {
        <div class="detail-card">
          <ng-container *ngTemplateOutlet="printItemList; context: { $implicit: item.items }" />
        </div>
      }
      @case ('heading') {
        @if (item.boxed) {
          <div class="detail-card-title-wrapper">
            <h6 class="detail-card-title">{{ item.value }}</h6>
            @if (item.tooltipKey) {
              <app-tooltip [text]="item.tooltipKey" />
            }
          </div>
        } @else {
          <h6 class="subsection-title mt-16">
            {{ item.value }}
            @if (item.tooltipKey) {
              <app-tooltip [text]="item.tooltipKey" />
            }
          </h6>
        }
      }
      @case ('text') {
        <p class="field-value">{{ item.value }}</p>
      }
      @case ('paragraph') {
        <p class="field-value">{{ item.value }}</p>
      }
      @case ('banner') {
        <div class="restricted-access">
          <img src="assets/images/danger-exclamation-mark.svg" alt="warning" />
          <span>{{ labels.section('restrictedAccess') }}</span>
          @if (item.tooltipKey) {
            <app-tooltip [text]="item.tooltipKey" />
          }
        </div>
      }
      @case ('consent') {
        <div class="consent-section">
          <div class="consent-item">
            <i class="bi bi-check-circle-fill consent-check"></i>
            <span class="consent-text">{{ item.value }}</span>
          </div>
        </div>
      }
      @case ('table') {
        @if (item.line.label) {
          <p class="field-label-bold table-title">{{ item.line.label }}</p>
        }
        <div class="ro-table-section">
          <div class="ro-table-border">
            <div class="ro-table-row ro-table-header-row">
              <div class="ro-table-row-fields">
                @for (col of item.line.columns ?? []; track col.key) {
                  <div class="ro-table-header-cell">{{ col.label }}</div>
                }
              </div>
            </div>
            <div class="ro-table-rows">
              @for (row of item.line.rows ?? []; track $index) {
                <div class="ro-table-row">
                  <div class="ro-table-row-fields">
                    @for (cell of row; track $index) {
                      <div class="ro-table-cell">{{ cell }}</div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
      @case ('documents') {
        <div class="documents-subsection">
          <h6 class="subsection-title">{{ item.line.label }}</h6>
          @for (doc of item.line.documents ?? []; track doc.fileId) {
            <div class="info-field">
              <p class="field-value">
                <a class="client-link" (click)="downloadPrintDocument(doc)" (keydown.enter)="downloadPrintDocument(doc)" tabindex="0">{{ doc.fileName }}</a>
                <span class="file-size"> ({{ doc.size }})</span>
              </p>
              <p class="field-value">{{ doc.comment || '-' }}</p>
            </div>
          }
        </div>
      }
    }
  }
</ng-template>
